// src/utils/timezone.js — Shared timezone offset utility
// Returns the UTC offset string (e.g. "-06:00") for an IANA timezone on a given date,
// accounting for DST by sampling at noon on the target date.

/**
 * @param {string} dateStr - "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm"
 * @param {string} timezone - IANA string e.g. "America/Chicago"
 * @returns {string} "+HH:MM" or "-HH:MM"
 */
export const getIANAOffset = (dateStr, timezone) => {
  try {
    const datePart = dateStr.split('T')[0];
    // Use noon UTC on the date to get a DST-correct offset
    const ref = new Date(datePart + 'T12:00:00Z');
    const parts = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      timeZoneName: 'shortOffset'
    }).formatToParts(ref);
    const tzStr = parts.find(p => p.type === 'timeZoneName')?.value ?? '';
    // tzStr is like "GMT-6" or "GMT+5:30"
    const match = tzStr.match(/GMT([+-])(\d+)(?::(\d+))?/);
    if (!match) return '+00:00';
    const sign = match[1];
    const h = match[2].padStart(2, '0');
    const m = (match[3] ?? '00').padStart(2, '0');
    return `${sign}${h}:${m}`;
  } catch {
    return '+00:00';
  }
};
